import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme, type ThemePref } from "../theme";
import { IconButton } from "./Button";
import { SegmentedControl, type SegmentedOption } from "./Toggles";

export interface ThemeToggleProps {
  size?: "sm" | "md";
  className?: string;
}

/** One-click light/dark switch (sun in dark, moon in light). Picking one stops following the device. */
export function ThemeToggle({ size = "md", className }: ThemeToggleProps) {
  const { theme, setPref } = useTheme();
  const next = theme === "dark" ? "light" : "dark";
  const iconSize = size === "sm" ? 15 : 17;
  return (
    <IconButton
      label={next === "light" ? "Switch to light mode" : "Switch to dark mode"}
      icon={next === "light" ? <Sun size={iconSize} /> : <Moon size={iconSize} />}
      size={size}
      className={className}
      onClick={() => setPref(next)}
    />
  );
}

const THEME_OPTIONS: ReadonlyArray<SegmentedOption<ThemePref>> = [
  { value: "system", label: "System", icon: <Monitor size={14} /> },
  { value: "light", label: "Light", icon: <Sun size={14} /> },
  { value: "dark", label: "Dark", icon: <Moon size={14} /> },
];

export interface ThemeSelectProps {
  size?: "sm" | "md";
  block?: boolean;
  className?: string;
}

/** System / Light / Dark choice, for settings screens. */
export function ThemeSelect({ size = "md", block, className }: ThemeSelectProps) {
  const { pref, setPref } = useTheme();
  return (
    <SegmentedControl
      label="Theme"
      options={THEME_OPTIONS}
      value={pref}
      onChange={setPref}
      size={size}
      block={block}
      className={className}
    />
  );
}
